import { withI18n } from 'react-i18next';
import CreditsTableDesktop from './CreditsTableDesktop';

export const pureComponent = CreditsTableDesktop;
export default withI18n()(CreditsTableDesktop);
